module.exports = __webpack_public_path__ + "swiper-icon-next-12adf25b.png";